import { type AnyElement, type AnyElementData } from '../all-element-types.ts';
import {
  type ElementData,
  type Element,
  elementType,
  type ElementType,
} from '../element.ts';

import { type LinkOrSmartLink, type SmartLinkKind } from './smart-link.ts';
import { type UnfurlData } from './unfurling.ts';

export type LinkOrIssue = LinkOrSmartLink;
export type IssueKind = SmartLinkKind;

export interface IssueElementData extends ElementData<ElementType>, UnfurlData {
  url: string;
  supportedViews: IssueKind[];
  kind: IssueKind;
  supportsPreview: boolean;
  ari?: string;
  rotation?: number;
  /**
   * ⚠️ If we ever add basisSize and basisPosition here, ensure that the corresponding type-guards
   * are updated accordingly in @link packages/sizing-feature-flags/src/sizing-feature-flags.ts
   */
}
export interface IssueElement extends IssueElementData, Element<ElementType> {}

export function isIssue(element: AnyElement | undefined): element is IssueElement {
  return !!element && element.type === issueElementType;
}

export function isIssueData(
  element: AnyElementData | undefined,
): element is IssueElementData {
  return !!element && element.type === issueElementType;
}

export const issueElementType = elementType('issue');
